export const CautionIcon = () => (
	<svg
		width='70'
		height='70'
		viewBox='0 0 70 70'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<g clipPath='url(#clip0_10997_140317)'>
			<path
				d='M59.7857 69.9891H10.2138C2.63087 69.9891 -2.30112 62.009 1.09005 55.2266L25.8759 5.65445C29.6351 -1.86398 40.3643 -1.86398 44.1235 5.65445L68.9094 55.2265C72.3008 62.009 67.3688 69.9891 59.7857 69.9891Z'
				fill='url(#paint0_linear_10997_140317)'
			/>
			<path
				d='M59.7857 69.9891H10.2138C2.63087 69.9891 -2.30112 62.009 1.09005 55.2266L25.8759 5.65445C29.6351 -1.86398 40.3643 -1.86398 44.1235 5.65445L68.9094 55.2265C72.3008 62.009 67.3688 69.9891 59.7857 69.9891Z'
				fill='url(#paint1_linear_10997_140317)'
			/>
			<path
				d='M66.4527 56.4512L41.6669 6.8792C40.3765 4.2985 37.8836 2.75781 34.9984 2.75781C32.1132 2.75781 29.6203 4.2985 28.3299 6.8792L3.54393 56.4512C2.3799 58.7793 2.50186 61.4911 3.87028 63.7051C5.23869 65.9193 7.60967 67.2412 10.2124 67.2412H59.7844C62.3871 67.2412 64.7581 65.9193 66.1265 63.7051C67.4948 61.4911 67.6169 58.7794 66.4527 56.4512ZM63.7915 62.2619C62.9269 63.6608 61.429 64.496 59.7846 64.496H10.2124C8.56793 64.496 7.0699 63.6608 6.20543 62.2619C5.34082 60.8631 5.26371 59.1498 5.99926 57.6788L30.7851 8.10693C31.6126 6.45209 33.148 5.50299 34.9983 5.50299C36.8485 5.50299 38.3841 6.45209 39.2114 8.10693L63.9973 57.679C64.733 59.1498 64.656 60.8631 63.7915 62.2619Z'
				fill='url(#paint2_linear_10997_140317)'
			/>
			<path
				d='M59.7885 69.9833H55.8851L33.3218 47.42C32.6548 47.0934 32.3198 46.5293 32.3198 45.7236C32.3198 42.6793 32.1948 40.5079 31.9451 33.6177C31.6953 26.7289 31.5703 25.3138 31.5703 22.2695C31.5703 21.2977 31.901 20.5484 32.5626 20.0199C33.2228 19.4902 34.0792 19.2266 35.1306 19.2266C36.182 19.2266 36.9547 19.5011 37.4461 20.0515C37.5408 20.1558 58.1097 40.7179 65.2098 47.8153L68.913 55.2215C72.3047 62.0033 67.3719 69.9833 59.7885 69.9833Z'
				fill='url(#paint3_linear_10997_140317)'
			/>
			<path
				d='M54.2759 69.9837H44.067L32.3633 58.2801C31.5851 57.5937 31.1953 56.7937 31.1953 55.878C31.1953 54.9242 31.5851 54.113 32.3633 53.446C33.1415 52.7789 34.0872 52.4453 35.199 52.4453C36.1776 52.4453 37.0245 52.7789 37.7381 53.446L54.2759 69.9837Z'
				fill='url(#paint4_linear_10997_140317)'
			/>
			<path
				d='M31.1953 55.8773C31.1953 54.9234 31.5844 54.1132 32.3625 53.4463C33.1407 52.7791 34.0865 52.4447 35.1982 52.4447C36.1772 52.4447 37.0235 52.7791 37.7372 53.4463C38.451 54.1132 38.809 54.9234 38.809 55.8773C38.809 56.7928 38.4512 57.5935 37.7372 58.2799C37.0235 58.9665 36.1771 59.3096 35.1982 59.3096C34.0864 59.3096 33.1407 58.9663 32.3625 58.2799C31.5844 57.5935 31.1953 56.7929 31.1953 55.8773ZM31.5698 22.2699C31.5698 21.2985 31.9002 20.5482 32.5615 20.0197C33.2226 19.4911 34.0787 19.2266 35.1299 19.2266C36.1812 19.2266 36.9535 19.5018 37.446 20.0517C37.9383 20.6015 38.1851 21.3408 38.1851 22.2699C38.1851 25.3145 38.1323 26.7287 38.0291 33.6187C37.9247 40.5089 37.8732 42.68 37.8732 45.7233C37.8732 46.3584 37.5758 46.8555 36.9819 47.2143C36.3871 47.5731 35.7698 47.7528 35.1301 47.7528C33.2561 47.7528 32.3189 47.0769 32.3189 45.7233C32.3189 42.68 32.1939 40.5089 31.9444 33.6187C31.6945 26.7286 31.5698 25.3144 31.5698 22.2699Z'
				fill='white'
			/>
		</g>
		<defs>
			<linearGradient
				id='paint0_linear_10997_140317'
				x1='17.5562'
				y1='29.9434'
				x2='97.4066'
				y2='109.794'
				gradientUnits='userSpaceOnUse'
			>
				<stop stopColor='#FFB92D' />
				<stop
					offset='1'
					stopColor='#F59500'
				/>
			</linearGradient>
			<linearGradient
				id='paint1_linear_10997_140317'
				x1='28.1563'
				y1='40.5432'
				x2='52.2262'
				y2='64.6118'
				gradientUnits='userSpaceOnUse'
			>
				<stop stopColor='#FFB92D' />
				<stop
					offset='1'
					stopColor='#F59500'
				/>
			</linearGradient>
			<linearGradient
				id='paint2_linear_10997_140317'
				x1='2.74995'
				y1='35.0002'
				x2='67.2456'
				y2='35.0002'
				gradientUnits='userSpaceOnUse'
			>
				<stop stopColor='#FFF465' />
				<stop
					offset='1'
					stopColor='#FFE600'
				/>
			</linearGradient>
			<linearGradient
				id='paint3_linear_10997_140317'
				x1='57.8575'
				y1='56.2842'
				x2='18.8656'
				y2='17.2923'
				gradientUnits='userSpaceOnUse'
			>
				<stop
					stopColor='#BE3F45'
					stopOpacity='0'
				/>
				<stop
					offset='1'
					stopColor='#BE3F45'
				/>
			</linearGradient>
			<linearGradient
				id='paint4_linear_10997_140317'
				x1='45.2315'
				y1='66.0512'
				x2='32.5124'
				y2='53.3307'
				gradientUnits='userSpaceOnUse'
			>
				<stop
					stopColor='#BE3F45'
					stopOpacity='0'
				/>
				<stop
					offset='1'
					stopColor='#BE3F45'
				/>
			</linearGradient>
			<clipPath id='clip0_10997_140317'>
				<rect
					width='70'
					height='70'
					fill='white'
				/>
			</clipPath>
		</defs>
	</svg>
);
